/* import __COLOCATED_TEMPLATE__ from './attribute-manual-tag-component.hbs'; */
/* RESPONSIBLE TEAM: unused-components */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import { alias } from '@ember/object/computed';
import AttributeComponent from 'embercom/components/attribute-component';

let ProfileManualTagsComponent = AttributeComponent.extend({
  tags: alias('userOrCompany.tags'),
  spaceSeparated: false,
});

export default ProfileManualTagsComponent;
